enum RequiredResidencyProperties {
	None = 0,
	PostalCode = 1,
	State = 2,
	City = 4,
	Street = 8,
	StreetNumber = 16,
	Unit = 32,
	Suffix = 64,
	Zone = 128
}

export default RequiredResidencyProperties;
